import { useState } from 'react';

/*
  DASHBOARD SECTION TUTORIALS
  ---------------------------
  8 tutorial areas. Click the "Tutorial" button on a dashboard section ->
  popup with embedded Google Drive video + title + subtitle.
*/
export const TUTORIALS = {
  retail:     { title: "Online Arbitrage Retailers", subtitle: "Source the best OA retailers and resell on Amazon.",        driveId: "1PJavinZJ_35MBlPMudsgJWn8eYMF0eYe" },
  tutorials:  { title: "Watch Tutorials",            subtitle: "Learn how to use Nepeto end to end.",                      driveId: "1osKHpO42KDbnuTdscTR2dd5HaxN0htQ1" },
  master:     { title: "Nepeto Master Search",       subtitle: "Find the best products FASTER with Master Search.",        driveId: "14b3Q29oyZU0FvbpAXIcZ8IJjsqB8i8hP" },
  liveSearch: { title: "Live Search",                subtitle: "Source live with Nepeto's powerful algorithm.",            driveId: "1nKy5Jp4WrdzzZTZMgguMT0WwPTEexPdU" },
  storefront: { title: "Storefront Scanner",         subtitle: "Scan a storefront and see where they buy their leads.",    driveId: "1kq5pTyi1Ym8R-xfCR6jDsFBUHpVrz0kr" },
  oos:        { title: "Be The Only Seller",         subtitle: "Sell products that are out of stock and be the only seller.", driveId: "1pl7aYA7PRnCMYg-x7m6s8M6aHOOZ9WOX" },
  csv:        { title: "CSV Scanner",                subtitle: "Scan a CSV file and get all the data you need.",           driveId: "1g4lFXU0FDFhUJrclH7JMMCHU02eq-xPZ" },
  a2a:        { title: "Amazon to Amazon Flips",     subtitle: "Buy on a price drop and sell when the price recovers.",    driveId: "1Ky9Ly1S2x5QjCxxr7gzt_UO8XjOK2jEF" },
};

// Accept a full Drive share URL or a bare file id, return a preview embed URL.
function driveEmbed(idOrUrl) {
  let id = String(idOrUrl || "");
  const m = id.match(/\/d\/([^/]+)/) || id.match(/[?&]id=([^&]+)/);
  if (m) id = m[1];
  return `https://drive.google.com/file/d/${id}/preview`;
}

export function TutorialButton({ tutKey }) {
  const [open, setOpen] = useState(false);
  const tut = TUTORIALS[tutKey];
  if (!tut) return null;
  return (
    <>
      <button
        className="button tut-btn"
        aria-label={"Tutorial: " + tut.title}
        title={"Watch the " + tut.title + " tutorial"}
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
      >
        Tutorial
      </button>
      {open && <TutorialModal tutKey={tutKey} onClose={() => setOpen(false)} />}
    </>
  );
}

function TutorialModal({ tutKey, onClose }) {
  const tut = TUTORIALS[tutKey];
  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={onClose}></div>
      <div className="modal-content tut-modal">
        <div className="box" style={{ textAlign: "center" }}>
          <p className="tut-title">{tut.title}</p>
          <p className="tut-subtitle">{tut.subtitle}</p>
          <div className="tut-video">
            <iframe
              src={driveEmbed(tut.driveId)}
              title={tut.title}
              allow="autoplay; fullscreen"
              allowFullScreen
            ></iframe>
          </div>
          <button className="button is-success" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
